import React from "react";
import { Header } from "../../components/Header";
import "./styles.less";
import { CustomerDetailBanner } from "../../blocks/heigh-educate-banner";
import { useTranslation } from "react-i18next";
import { CommonPageLink } from "../../blocks/common-page-link";
import { CustomerDetailIntro } from "../../blocks/customer-detail-intro";
import { Footer } from "../../components/FooterV2";
import { CustomerDetailChallenge } from "../../blocks/customer-detail-challenge";
import { CustomerDetailIdea } from "../../blocks/customer-detail-idea";
import { HomeTryOn } from "../../blocks/home-try-on";
import { Helmet } from "react-helmet";
import { Notice } from "../../components/Notice";

export const BentleyPage = () => {
  const { t } = useTranslation();
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  const challenges = [
    {
      title: t("customer.bentley.challenge.item1.title"),
      description: t("customer.bentley.challenge.item1.description"),
    },
    {
      title: t("customer.bentley.challenge.item2.title"),
      description: t("customer.bentley.challenge.item2.description"),
    },
    {
      title: t("customer.bentley.challenge.item3.title"),
      description: t("customer.bentley.challenge.item3.description"),
    },
  ];
  const ideas = [
    {
      title: t("customer.bentley.ideas.item1.title"),
      descript: t("customer.bentley.ideas.item1.subtitle"),
      icon: "authing-like",
    },
    {
      title: t("customer.bentley.ideas.item2.title"),
      descript: t("customer.bentley.ideas.item2.subtitle"),
      icon: "authing-insurance",
    },
    {
      title: t("customer.bentley.ideas.item3.title"),
      descript: t("customer.bentley.ideas.item3.subtitle"),
      icon: "authing-idcard",
    },
  ];
  return (
    <div className="bentley-page">
      <Helmet>
        <title>
          奔特利SSO单点登录案例_奔特利统一身份认证客户案例-Authing身份云以开发者为中心
        </title>
      </Helmet>
      <Header mode="dark" defaltNav={true} hasNotice />
      <CustomerDetailBanner
        title={t("customer.bentley.banner.title")}
        addtionTitle={t("customer.bentley.banner.addtionTitle")}
        subtitle={t("customer.bentley.banner.subtitle")}
        theme="#67AD5B"
        imgUrl={
          "//files.authing.co/authing-website/customer-banner-bentley-tiny.png"
        }
        alt="bentley单点登录系统"
      />
      <CustomerDetailIntro
        imgUrl={t("customer.bentley.intro.imgUrl")}
        alt="企业服务身份管理体系"
        content={
          <>
            <p>{t("customer.bentley.intro.descript1")}</p>
            <p>{t("customer.bentley.intro.descript2")}</p>
          </>
        }
      />
      <CustomerDetailChallenge challenges={challenges} theme={"#67AD5B"} />
      <CustomerDetailIdea ideas={ideas} theme={"#67AD5B"} />
      <CommonPageLink pagesLink={pagesLink} theme={"#67AD5B"} />
      {/* <CustomerConsult /> */}
      <div style={{ paddingTop: 120 }}>
        <HomeTryOn />
      </div>
      <Footer />
    </div>
  );
};
